import { render, staticRenderFns } from "./trusteeshipFund.vue?vue&type=template&id=be2f528e"
import script from "./trusteeshipFund.vue?vue&type=script&lang=js"
export * from "./trusteeshipFund.vue?vue&type=script&lang=js"
import style0 from "./trusteeshipFund.vue?vue&type=style&index=0&id=be2f528e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports